<div class="header bg-gradient-primary py-7 py-lg-8">
  <div class="container">
    <div class="header-body text-center mb-5">
      <div class="row justify-content-center"></div>
    </div>
  </div>
</div>
<!-- Page content -->
<div class="container mt--8 pb-5">
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center mb-4">
            <img
              src="assets/img/brand/logo-invertida.png"
              class="img-fluid login-logo"
              alt="Tem Cashback"
            />
          </div>
          <div class="text-center mb-4">
            Tem Cashback | Painel Administrativo
          </div>
          <form [formGroup]="formLogin" (submit)="login()">
            <div class="form-group mb-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"
                    ><i class="ni ni-email-83"></i
                  ></span>
                </div>
                <input
                  class="form-control"
                  placeholder="e-mail"
                  type="email"
                  formControlName="email"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"
                    ><i class="ni ni-lock-circle-open"></i
                  ></span>
                </div>
                <input
                  class="form-control"
                  placeholder="senha"
                  type="password"
                  formControlName="password"
                />
              </div>
            </div>
            <div
              class="custom-control custom-control-alternative custom-checkbox"
            >
              <input
                class="custom-control-input"
                id=" customCheckLogin"
                type="checkbox"
              />
              <label class="custom-control-label" for=" customCheckLogin">
                <span class="text-muted">Lembra-me</span>
              </label>
            </div>
            <div class="text-center">
              <button type="submit" class="btn btn-primary my-4 w-100" [disabled]="loading">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                Entrar
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a href="javascript:void(0)" class="text-light"
            ><small>Perdeu a senha?</small></a
          >
        </div>
      </div>
    </div>
  </div>
</div>
